import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles, manager, teamAdmin, teamMember } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { requestsLoader } from '../loaders/requests';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const RequestPage = lazy(() => import('../../components/pages/request'));

const requestPath = '/requests' as const;

export const requestRoutes = {
	path: requestPath,
	element: <Outlet />,
	children: [
		{
			path: ':requestId',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager, teamMember]}>
					<Suspense fallback={<PageLoader />}>
						<RequestPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, requestData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					requestsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...requestData,
				};
			},
		},
	],
};
